var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("LoginRedirect", {
    attrs: { currentStep: _vm.currentStep, allDone: _vm.allDone },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }